module.exports = __webpack_public_path__ + "static/ebook-banner-5fc14560cd2203e43a61f012431ef017.jpg";